// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_recordPageViewForLoggedInUser(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["PageViewRecorded"]);
}

let variablesConverter = {"recordPageViewForLoggedInUserInput":{"pageView":{"r":"pageViewV5Input"}},"pageViewV5Input":{"viewedAt":{"b":""},"data":{"b":""}},"__root":{"input":{"r":"recordPageViewForLoggedInUserInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"recordPageViewForLoggedInUser":{"u":"response_recordPageViewForLoggedInUser"}}};

let wrapResponseConverterMap = {
  response_recordPageViewForLoggedInUser: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"recordPageViewForLoggedInUser":{"u":"response_recordPageViewForLoggedInUser"}}};

let responseConverterMap = {
  response_recordPageViewForLoggedInUser: unwrap_response_recordPageViewForLoggedInUser
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function mediumV5_decode($$enum) {
  if ($$enum === "EMAIL" || $$enum === "WEB") {
    return $$enum;
  }
}

let mediumV5_fromString = mediumV5_decode;

function pageV5_decode($$enum) {
  if ($$enum === "ACTIVITY_REPORT_PAGE" || $$enum === "SHOWINGS_PAGE" || $$enum === "AGENT_PAGE" || $$enum === "SHARE_PROPERTY_PAGE" || $$enum === "ALL_IN_PAGE" || $$enum === "PROPERTY_PAGE" || $$enum === "BUYER_NEEDS_PAGE" || $$enum === "PROPERTIES_PAGE" || $$enum === "BUYER_NEED_PAGE" || $$enum === "PLANS_PAGE" || $$enum === "CHAPTER_DASHBOARD_PAGE" || $$enum === "NEW_SELLER_PAGE" || $$enum === "CLIENT_MATCH_PAGE" || $$enum === "MESSAGES_PAGE" || $$enum === "CONVERSATIONS_PAGE" || $$enum === "MAILED_PROPERTY_PAGE") {
    return $$enum;
  }
}

let pageV5_fromString = pageV5_decode;

function resourceTypeV5_decode($$enum) {
  if ($$enum === "ACTIVITY_REPORT" || $$enum === "USER" || $$enum === "BROADCAST_MESSAGE" || $$enum === "RENTAL_PROPERTY" || $$enum === "BUYER_NEED" || $$enum === "RENTAL_NEED" || $$enum === "CONVERSATION" || $$enum === "QA_MESSAGE" || $$enum === "EMAIL_NOTIFICATION" || $$enum === "PROPERTY") {
    return $$enum;
  }
}

let resourceTypeV5_fromString = resourceTypeV5_decode;

let Utils = {
  mediumV5_decode: mediumV5_decode,
  mediumV5_fromString: mediumV5_fromString,
  pageV5_decode: pageV5_decode,
  pageV5_fromString: pageV5_fromString,
  resourceTypeV5_decode: resourceTypeV5_decode,
  resourceTypeV5_fromString: resourceTypeV5_fromString
};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PageViews_RecordPageViewForLoggedInUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "recordPageViewForLoggedInUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "PageViewRecorded",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageViews_RecordPageViewForLoggedInUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "recordPageViewForLoggedInUser",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6aef190e84f42e687238257711f18a03",
    "id": null,
    "metadata": {},
    "name": "PageViews_RecordPageViewForLoggedInUserMutation",
    "operationKind": "mutation",
    "text": "mutation PageViews_RecordPageViewForLoggedInUserMutation(\n  $input: RecordPageViewForLoggedInUserInput!\n) {\n  recordPageViewForLoggedInUser(input: $input) {\n    __typename\n    ... on PageViewRecorded {\n      __typename\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_recordPageViewForLoggedInUser = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_recordPageViewForLoggedInUser = unwrap_response_recordPageViewForLoggedInUser;
exports.wrap_response_recordPageViewForLoggedInUser = wrap_response_recordPageViewForLoggedInUser;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
